<template>
  <generic-container
    :title="$t('sociocultural representations')"
    icon="quidditch"
    :header_buttons="header_buttons"
  >
    <div class="ui form">
      <table ref="table" class="ui celled unstackable selectable striped table" style="width:100%">
        <thead>
          <tr>
            <th>{{ $t("id") }}</th>
            <th>{{ $t("name") }}</th>
            <th>{{ $t("site") }}</th>
            <th>{{ $t("cultural area") }}</th>
            <th>{{ $t("cultural sub-area") }}</th>
            <th>{{ $t("region") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(piece, index) in pieces" :key="index" @click="show_piece(piece)">
            <td>{{ piece.piece_id }}</td>
            <td>{{ piece.setup.name }}</td>
            <td>{{ piece.setup.site }}</td>
            <td>{{ piece.setup.cultural_area }}</td>
            <td>{{ piece.setup.cultural_subarea }}</td>
            <td>{{ piece.setup.region }}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <th>{{ $t("id") }}</th>
            <th>{{ $t("name") }}</th>
            <th>{{ $t("description") }}</th>
            <th>{{ $t("cultural area") }}</th>
            <th>{{ $t("deposit") }}</th>
            <th>{{ $t("site") }}</th>
          </tr>
        </tfoot>
      </table>
    </div>
  </generic-container>
</template>

<script>
import filters from "@/filters";
import { local_api, error_toast } from "@/utils";
import GenericContainer from "@/components/GenericContainer";
import "datatables.net";
require("datatables.net-buttons")(window, window.jQuery);
require("datatables.net-buttons/js/buttons.html5")(window, window.jQuery);
require("datatables.net-buttons/js/dataTables.buttons")(window, window.jQuery);
require("datatables.net-buttons-se")(window, window.jQuery);
require("datatables.net-buttons-se/js/buttons.semanticui")(
  window,
  window.jQuery
);
import "datatables.net-se";

// @ is an aliass to /src
export default {
  name: "ArcheologyCatalog",
  components: {
    "generic-container": GenericContainer
  },
  filters: filters,
  data() {
    return {
      pieces: [],
      datatable: undefined,
      header_buttons: [
        {
          icon: "arrow left",
          color: "",
          click: this.back,
          tooltip: this.$t("back")
        },
        {
          icon: "file download",
          color: "green",
          click: this.export,
          tooltip: this.$t("export")
        }
      ]
    };
  },
  methods: {
    show_piece(piece) {
      this.$router.push({
        name: "ArcheologyPieceView",
        query: { u: piece.uuid }
      });
    },
    back() {
      this.$router.go(-1);
    },
    update_table() {
      let vm = this;
      setTimeout(() => {
        if (vm.datatable) vm.datatable.columns.adjust().draw();
      }, 500);
    },
    export() {
      let vm = this;
      local_api(vm, "post", "/archeology/do-export-catalog")
        .then(csvstring => {
          var CsvString =
            "data:application/csv," + encodeURIComponent(csvstring);
          var x = document.createElement("A");
          x.setAttribute("href", CsvString);
          x.setAttribute("download", "somedata.csv");
          document.body.appendChild(x);
          x.click();
        })
        .catch(err => {
          vm.$alertify.error(err);
        });
    }
  },
  created() {
    let vm = this;
    local_api(vm, "post", "/archeology/do-get-all-pieces")
      .then(r => {
        vm.pieces = r;
        setTimeout(() => {
          let lng =
            "https://cdn.datatables.net/plug-ins/1.10.21/i18n/Spanish.json";
          vm.datatable = window.jQuery(vm.$refs.table).DataTable({
            autoWidth: true,
            dom: "lBfrtip",
            buttons: ["csv", "excel", "pdf"],
            language: {
              url: lng
            },
            initComplete: function() {
              // Apply the search
              this.api()
                .columns()
                .every(function() {
                  var that = this;
                  window
                    .jQuery("input", this.footer())
                    .on("keyup change clear", function() {
                      if (that.search() !== this.value) {
                        that.search(this.value).draw();
                      }
                    });
                });
              vm.update_table();
            }
          });
        }, 500);
      })
      .catch(err => {
        error_toast(err);
      });
  },
  mounted() {
    let vm = this;
    window
      .jQuery(vm.$refs.table)
      .find("tfoot th")
      .each(function() {
        var title = window.jQuery(this).text();
        window
          .jQuery(this)
          .html(
            '<input type="text" placeholder="' +
              vm.$t("search") +
              " " +
              title +
              '" />'
          );
      });
  },
  watch: {}
};
</script>

<style>
.dataTables_length,
.dataTables_paginate,
.dataTables_filter {
  display: inline-block;
}

.dataTables_filter,
.dataTables_paginate {
  float: right;
}

.dt-buttons {
  margin-left: 70px !important;
}
</style>
